import { render, staticRenderFns } from "./voiceset.vue?vue&type=template&id=f92fb874&scoped=true&"
import script from "./voiceset.vue?vue&type=script&lang=js&"
export * from "./voiceset.vue?vue&type=script&lang=js&"
import style0 from "./voiceset.vue?vue&type=style&index=0&lang=css&"
import style1 from "./voiceset.vue?vue&type=style&index=1&id=f92fb874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92fb874",
  null
  
)

export default component.exports